import script from "./SuccessResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessResult.vue?vue&type=script&setup=true&lang=js"

import "./SuccessResult.vue?vue&type=style&index=0&id=9274190a&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-rating-component-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9274190a"]])

export default __exports__